
<template>
  <div class="content" style="overflow-x: hidden" id="homepage">
  <div :class="$i18n.locale == 'en'?'box englishStyle':'box'">
    <div id="screen" class="screen">
    <div class="box01">
      <!--历史销售数据 开始-->
      <div class="xssj">
        <div class="box_bt"><a class="xssj_img0"><img src="@/assets/images/bg30.png" /></a><a style="color: #000000;">{{$t('homepage.todaybeverage')}}</a>
      </div>
          <div class="image-container1" >
          <img src="@/assets/images/bg28.png"  class="image"/>
          <p style="position: absolute; top: 35px; color: #00BCFA; font-size: 40px; font-family: BlinkMacSystemFont;">
            {{ YearCupCountA }}</p>
        </div>

      <!--历史销售数据 结束
      历史设备销售排行榜TOP10 开始-->
      <div class="sbph" v-if="equiploading" ><div style="margin-top:45%;color: #000000;"><i class="el-icon-loading"></i>{{$t('homepage.dataLoading')}}...</div></div>
        <div class="sbph" v-if="!equiploading" style="overflow-y: auto; max-height: 510px;">
          <div class="box_bt" style="margin:0px 0 10px">
            <a><img src="@/assets/images/bg30.png" /></a>
            <a style="color: #000000;">&nbsp;{{$t('homepage.equipdailydata')}}</a>
            <el-button style="color: #000000; float: right;" type="text" @click="TodayCupOrdersCount">{{$t('homepage.equiptotaldata')}}</el-button>
          </div>
          <div>
            <el-row :gutter="24" class="sbph_row01" >
              <el-col :span="2" style="line-height: 1;color: #000000">{{$t('homepage.ranking')}}</el-col>
              <el-col :span="5" style="line-height: 1;color: #000000">{{$t('homepage.equipmentNo')}}</el-col>
              <el-col :span="5" style="line-height: 1;color: #000000">{{$t('equipmentName')}}</el-col>
              <el-col :span="4" style="line-height: 1;color: #000000">{{$t('username')}}</el-col>
              <el-col :span="4" style="line-height: 1;color: #000000">{{$t('homepage.salestoday')}}</el-col>
              <el-col :span="4" style="line-height: 1;color: #000000">{{$t('homepage.amounttoday')}}</el-col>
            </el-row>

            <el-row :gutter="24"  v-for="(item,index) in todaySaleList" :key="index" :class="addclass3(index)"  style="border-image: linear-gradient(to right, #233E9A, #33ACDF, #233E9A) 10;border-bottom: 4px solid transparent;line-height: 25px;">
              <el-col :span="2" :class="addclass1(index)" style="font-size: 14px;margin:5px 0 5px;">{{index+1}}</el-col>
              <el-col :span="5" style="font-size: 120%;margin: 5px 0px;color: #000000;text-overflow: ellipsis;overflow: hidden; white-space: nowrap" :title="item.equipNo">{{item.equipNo}}
              </el-col>
              <el-col :span="5" style="font-size: 120%;margin: 5px 0px;color: #000000;text-overflow: ellipsis;overflow: hidden; white-space: nowrap" :title="item.equipName">{{item.equipName}}
              </el-col>
              <el-col :span="5" style="font-size: 120%;margin: 5px 0px;color: #000000;text-overflow: ellipsis;overflow: hidden; white-space: nowrap" :title="item.userName">{{item.userName}}</el-col>
              <el-col :span="3" :class="addclass2(index)" style="font-size: 14px;text-align: center;margin: 5px 0px;">{{item.cupCount}}</el-col>
                <el-col :span="3" :class="addclass2(index)" style="font-size: 14px;text-align: center;margin: 5px 0px;">{{item.cupSum}}</el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!--历史设备销售排行榜TOP10 结束-->
    </div>
    <div class="box02">
      <!--地图 开始-->
      <div class="map" :style="{ marginTop: '0px', background: '#E6E7E8', borderRadius: '5px', padding: '2px', height: '43vh', position: 'relative' }">
        <div class="map_img">
          <!--          <mapDrag lat="22.574405" lng="114.095388"></mapDrag>-->
          <BaiduMapComponent></BaiduMapComponent>
        </div>
      </div>
      <!--地图 结束-->
            <!--今日销售数据 开始-->
      <div class="lsxs" :style="{margintop:'10px',background:'#FFFFFF', border: '3px solid #E8E9EA',borderradius:'5px',padding:'10px',height:(1 * windowHeight) + 'px'}">
        <div class="box_bt"><a><img src="@/assets/images/bg30.png" style="margin-left: 340px"/></a><a style="color: #000000;">&nbsp;{{$t('homepage.todaySalesData')}}</a></div>
        <div id="main" style="margin-top:20px;width:80vh; height:50vh"></div>
      </div>
            <!--今日销售数据 结束-->
    </div>

    <div class="box03">
      <!--历史饮料排行 开始-->
      <div class="sqy">
        <div class="box_bt"><a>
          <img src="@/assets/images/bg30.png" />
        </a>
          <a style="color: #000000;">&nbsp;{{$t('equipmentmanagement.machineModel')}}</a>
          <el-button :style="{ width:'200px',height:'30px',marginLeft: '0px',marginTop: '0px',backgroundColor:'#ffffff',color:'#000000',borderColor:'#ffffff' }" @click="screen()">
            {{ fullscreen ? $t('homepage.closefullscreen') : $t('homepage.openfullscreen') }}
          </el-button></div>
        <div class="image-container">
          <img src="@/assets/images/bg35.png"  class="image1"/>
          <p style="position: absolute; top: 85px; left: 15%; color: #00BCFA; font-size: 28px; font-family: BlinkMacSystemFont;">{{equipStateNumberList.good+equipStateNumberList.offline+equipStateNumberList.abnormal+equipStateNumberList.notActivated}}</p>
          <img src="@/assets/images/bg36.png" class="image2"/>
          <p style="position: absolute; top: 80px; right: 42%; color: #FFDB83; font-size: 28px; font-family: BlinkMacSystemFont;">{{equipStateNumberList.online}}</p>
          <p style="position: absolute; top: 80px; right: 13%; color: #FFDB83; font-size: 28px; font-family: BlinkMacSystemFont;">{{equipStateNumberList.offline}}</p>
        </div>
<!--        <div id="main" style="width:400px;height:200px;"></div>-->
      </div>
      <!--历史饮料排行 结束
      历史报警统计 开始-->
      <div class="sqy1" style="margin-top:10px;height:1000px">
        <div class="box_bt"><a><img src="@/assets/images/bg30.png" /></a> <a style="color: #000000;">&nbsp;{{$t('homepage.alarmStatistics')}}</a>
        </div>
        <div class="image-container">
          <img src="@/assets/images/bg37.png"  class="image3"/>
          <p style="position: absolute; top: 25px; left: 110px; color: #000000; font-size: 20px; font-family: BlinkMacSystemFont;">{{$t('homepage.Currentlymalfunction')}} {{faultToalCount}}个</p>
          <p style="position: absolute; top: 90px; left: 110px; color: #0994BD; font-size: 20px; font-family: BlinkMacSystemFont;">{{$t('homepage.Currentlymalfunctionnow')}}</p>
        </div>
        <div class="tb">
          <div id="baojing" style="width:100%;height:100%;margin-top: 0px;margin-right: 50px"></div>
        </div>
      </div>
      <!--历史报警统计 结束-->
    </div>

  </div>
    <el-dialog
      :title="$t('homepage.equiptotaldata')"
      :visible.sync="ExTodayCountVisible"
      :close-on-click-modal="false"
      style="text-align: left;"
      :append-to-body="true"
      width="75%"
      :class="$i18n.locale=='zh'?'chineseForm':'englishForm'"
    >
      <el-row :gutter="24">
        <el-col :span="3">
          <el-input v-model="queryparam.equipmentNo" :placeholder="$t('equipmentNo')"  size="small"/>
        </el-col>
<!--        <el-col :span="2">
          <el-input v-model="queryparam.userName" :placeholder="$t('user')"  size="small"/>
        </el-col>-->
        <el-col :span="1">
          <el-button type="primary" size="small" @click="query(queryparam)"><i class="el-icon-search el-icon--left"></i>{{$t('equipmentmanagement.query')}}</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top:10px;">
        <el-col :span="24">
          <el-table
            ref="multipleTable"
            :data="saleRankList"
            stripe
            tooltip-effect="dark"
            style="width: 100%;margin-top: 10px;"
            :page-size="pageSize"

            :pager-count="11"
            max-height="520"
            @sort-change='sortChange'
          >
            <el-table-column
              type="index"
              :label="$t('serialNo')"
              width="100">
            </el-table-column>
            <el-table-column
              prop="equipNo"
              column-key="equipNo"
              :label="$t('equipmentNo')"
              :filter-multiple="false"
            >
            </el-table-column>
            <el-table-column
              prop="equipName"
              column-key="equipName"
              :label="$t('equipmentName')"
              :filter-multiple="false"
            >
            </el-table-column>
            <el-table-column
              prop="userName"
              :label="$t('username')"
              :filter-multiple="false"
            >
            </el-table-column>
            <el-table-column
              prop="cupCount"
              :label="$t('homepage.totalsales')"
              :filter-multiple="false"
            >
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-top:2%;text-align:right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            :page-sizes="[10, 20,50,100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalsaleRankCount">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
  </div>
</template>

<script>
  import mapDrag from '../../components/mapDrag'
  import BaiduMapComponent from "../../components/BaiduMapComponent.vue";
  // import {loading_start,loading_end} from '../../utils/loading.js'
  import  "../../utils/signalr.js";
  //先实例化连接对象
  var connection = new signalR.HubConnectionBuilder().withUrl("/signalrhub").build();
  export default {
    name:"homepage",
    components: {
      BaiduMapComponent
      //mapDrag
    },
    data(){
      return{
        browserWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        pageSize:10,
        pageIndex:1,
        ExTodayCountVisible:false,
        Todayloading:true,
        YearCupCount:[],
        YearCupCountA:0,
        defaulttime:['00:00:00','23:59:59'],
        equiploading:true,
        queryparam:new Object(),
        saleEquipChamp:new Object(),
        saleBeverageChamp:new Object(),
        paixuFaultdata:new  Object(),
        saleList:[],
        todaySaleList:[],
        saleRankList:[],
        beverageNumber:5,
        beverageRankList:[],
        beverageNameList:[],
        beverageValueList:[],
        saleWayRankList:[],
        saleWayNameList:[],
        saleWayValueList:[],
        saleWayNumber:5,
        equipStateNumberList:[],
        s:new Date(),
        allEquipmentPointsList:[],
        faultInfoList:[],
        queshuiFault:0,
        quefenFault:0,
        jspmFault:0,
        jbccleanFault:0,
        elseyunweiFault:0,
        jiqiFault:0,
        isshowFault:false,
        equipmentTypeId:-1,// 机器类型
        equipmentTypeOptions:[
          {
            name:'全部/ALL',
            id:-1
          }
        ],
        faultDetails:[],// 故障的集合
        fullscreen: false,
        faultToalCount:0,
        IsZHai:false,
        ZHaisaleRankList:[],
        userid:0,
        param:new Object(),
        currentPage1:1,
        totalMilkCupAllCount:0,
        totalsaleRankCount:0,
      }
    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
      if(this.$account.data)
      {
        if (this.$account.data.user!=null)
        {
          if (this.$account.data.user.id==511)
          {
            this.IsZHai=true;
          }
          else if(this.$account.data.user.parentId==511)
          {
            this.IsZHai=true;
          }
          else{
            this.IsZHai=false;
          }
        }
        else{
          this.IsZHai=false;
        }

      }
      else{
        window.location.href="/";
      }
/*      window.onresize = () => {
        if (document.fullscreenElement) {
          console.log('进入全屏');
        } else {
          // TODO...
          this.fullscreen = false;
          console.log('退出全屏');
        }
      };*/
      //this.loadBeverageRankData().promise,
      this.loadYearCupCountDataA();
      this.loadYearCupCountData();
      this.loadEquipStateNumber();
      this.loadTodaySaleDataRank(-1,0,false);
      //this.loadSaleDataRank(10);
      this.loadFaultInfoCount();
      this.initEquipmentType();

      let ttimer
      //},2000)
      //接收服务器发来的消息（注册事件）
      connection.on("updateProgress",  (message)=> {
        console.log("饮品推送");
        this.YearCupCountA = this.YearCupCountA + 1
      });
      //初始化，建立通讯
      connection.start().then(function () {
        console.log("连接成功");
      }).catch(function (err) {
        console.log("连接失败");
        let errStr = err.toString();
        return console.error(errStr);
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
      this.disconnectSignalR();
    },
    methods:{
      // 手动断开连接
      async disconnectSignalR() {
        if (this.connection) {
          await this.connection.stop();
        }
      },
      handleSizeChange(e){
        this.pageSize=e;
        this.currentPage1 = 1
        this.loadSaleDataRank(1)
      },
      handleCurrentChange(e){
        this.currentPage1 = e
        this.loadSaleDataRank(e)
      },
      //查询
      query(){
        this.loadSaleDataRank(1);
      },
      handleResize() {
        //this.chartInstance.resize();
        this.windowHeight = window.innerHeight;
        this.browserWidth = window.innerWidth;
        //console.log("当前高度"+this.windowHeight);
        //console.log("当前宽度"+this.browserWidth);
      },
      //监听排序
      sortChange({ prop, order }){
        this.order = order
        this.prop = prop;
        if(order == "ascending"){
          this.sequence=true;
        }else if(order == "descending"){
          this.sequence=false;
        }else{
          this.sequence = null
        }
        this.loadMilkEquipList(this.currentPage4);

      },
      TodayCupOrdersCount()
      {
        //IsZHai设置为true
        this.loadSaleDataRank(1);

        this.ExTodayCountVisible = true;

      },
      loadTodaySaleDataRank(pageIndex,number,IsZHai)
      {
        this.param = {
          pageIndex:pageIndex,
          pageSize:this.pageSize,
          order:this.prop,
          sequence:this.sequence,
          ...this.queryparam
        };
        let that = this;
        return this.$httpservice.get("api/Analysis/EquipmentZhaiRankingBySale",{number,...that.param}).then(
          function (data) {
            if(data.body.code=="200"){
              if(IsZHai){
                that.ZHaisaleRankList = data.body.data;
                that.totalMilkCupAllCount = data.body.totalCount;
                that.equiploading=false;
                return;
              }
              that.todaySaleList = data.body.data;

              that.equiploading =false;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      bSort(arr) {
        var len = arr.length;
        for (var i = 0; i < len-1; i++) {
          for (var j = 0; j < len - 1 - i; j++) {
            if (arr[j].value < arr[j + 1].value) {
              var temp = arr[j];
              arr[j] = arr[j+1];
              arr[j+1] = temp;
            }
          }
        }
        return arr;
      },
      //故障统计
      loadFaultInfoCount(){
        var faultInfoChart = this.$echarts.init(document.getElementById('baojing'));
        faultInfoChart.showLoading({
          text: this.$t('homepage.dataLoading')+'...',
          textStyle: { fontSize : 30 , color: '#000000' },
          effectOption: {backgroundColor: 'rgba(0, 0, 0, 0)'}
        });
        let that = this;
        // 饼图只显示当天数据，不受时间筛选的影响，所以原有的param要去掉
        let params = new Object()
        params.startTime = this.getCurrentDate() + " 00:00:00"
        params.endTime = this.getCurrentDate() + " 23:59:59"
        // 设备类型
        params.equipmentTypeId = this.equipmentTypeId
        this.$httpservice.get("api/Analysis/FaultInfoCount",params).then(
          function (data) {
            if(data.body.code=="200"){
              that.faultInfoList = data.body.data;
              that.faultInfoList.forEach(item => {
                that.faultToalCount += item.count;
              });
              that.queshuiFault = that.faultInfoList.filter(e=>e.type==0)[0].count
              that.quefenFault = that.faultInfoList.filter(e=>e.type==1)[0].count
              that.jspmFault = that.faultInfoList.filter(e=>e.type==2)[0].count
              that.jbccleanFault = that.faultInfoList.filter(e=>e.type==3)[0].count
              that.elseyunweiFault = that.faultInfoList.filter(e=>e.type==4)[0].count
              that.jiqiFault = that.faultInfoList.filter(e=>e.type==5)[0].count
              var chartdata = [
                { value: that.queshuiFault, name: that.$t('homepage.operationAndMaintenanceFailure')},
                { value: that.quefenFault, name: that.$t('homepage.waterCircuitUnitFailure')},
                { value: that.jspmFault, name: that.$t('homepage.heatingCoolingFailure')},
                { value: that.jbccleanFault, name: that.$t('homepage.feedingUnitFailure') },
                { value: that.elseyunweiFault, name: that.$t('homepage.controlSystemFailure') },
                { value: that.jiqiFault, name: that.$t('homepage.others') }
              ];
              that.paixuFaultdata = that.bSort(chartdata)
              //console.log("故障"+JSON.stringify(that.paixuFaultdata))
              //that.faultEcharts()

              var faultInfooption = {

                tooltip: {

                  trigger: 'item',
                },
                legend: {
                  bottom: 550 , // 设置底部距离为 20 像素
                  textStyle: { // 设置图例文本样式
                    color: '#000000', // 设置图例文本颜色为紫色
                  }
                },

                series: [
                  {
                    name: '故障列表',
                    type: 'pie',
                    radius: [10, 80  ],
                    center: ["50%", "18%"], 　　　　//这个属性调整图像的位置
                    roseType: 'area',
                    itemStyle: {
                      borderRadius: 8
                    },
                    label:{            //饼图图形上的文本标签
                      normal:{
                        show:true,
                        textStyle : {
                          color : '#000000',
                          fontWeight : 900 ,
                          fontSize : 10    //文字的字体大小
                        },

                      }
                    },
                    data: that.paixuFaultdata,
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                    },
                  }
                ]
              };
              faultInfoChart.setOption(faultInfooption);
              faultInfoChart.hideLoading();
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      // 日期工具类
      getCurrentDate() {
        let _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1;
        let dd = new Date().getDate();
        _this.gettime = yy+'-'+mm+'-'+dd;
        return _this.gettime
      },
      // 初始化设备类型
      initEquipmentType(){
        let that = this
        this.$httpservice.get('api/Equipment/EquipmentTypes').then(res=>{
          if(res.body.code == 200){
            that.equipmentTypeOptions = that.equipmentTypeOptions.concat(res.body.data)
          }
        })
      },
      //css 选择器
      addclass1(i){
        switch(i){
          case 0: return 'sbph_one';
          case 1: return 'sbph_two';
          case 2: return 'sbph_three';
          default:
            return 'sbph_four'; // 添加默认返回空字符串的情况
        }
      },
      addclass2(i){
        switch(i){
          case 0: return 'sbph1_td03';
          case 1: return 'sbph2_td03';
          case 2: return 'sbph3_td03';
          default:
            return 'sbph4_td03'; // 添加默认返回空字符串的情况
        }
      },
      addclass3(i){
        switch(i){
          case 0: return 'sbph5_td03';
          case 1: return 'sbph5_td03';
          case 2: return 'sbph5_td03';
        }
      },
      //加载设备销售数据排行
      loadSaleDataRank(pageIndex,IsZHai){
        let that = this;
        that.param = {
          pageIndex:pageIndex,
          pageSize:this.pageSize,
          order:this.prop,
          sequence:this.sequence,
          ...this.queryparam
        };
        return this.$httpservice.get("api/Analysis/EquipmentNameCountRankingBySaleC",that.param).then(
          function (data) {
            if(data.body.code=="200"){
              if(IsZHai){
                that.ZHaisaleRankList = data.body.data;

                return;
              }
              that.saleRankList = data.body.data;
              that.totalsaleRankCount=data.body.totalCount;
              that.equiploading =false;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      //今日销售数据
      loadYearCupCountData(){
        let that = this;
        let chartDom = document.getElementById('main');
        let myChart = this.$echarts.init(chartDom);
        myChart.showLoading({
          text: 'loading',
          textStyle: { fontSize: 30, color: '#000000' }, // 调整文字颜色为黑色
          backgroundColor: '#000000', // 设置背景色为白色并添加透明度
          effect : 'whirling',
          maskColor: '#ffffff'
        });
        return this.$httpservice.get("api/Analysis/EquipmentCountYear").then(
          function (data) {
            if(data.body.code=="200"){
              that.YearCupCount = data.body.data;
              that.Todayloading=false;
              //console.log("JYSSSSB"+JSON.stringify(that.YearCupCount))
              that.loadEquipMonthList(myChart);
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },

      loadYearCupCountDataA(){
        let that = this;
        return this.$httpservice.get("api/Analysis/EquipmentCountYearA").then(
          function (data) {
            if(data.body.code=="200"){
              that.YearCupCountA = data.body.data;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      loadEquipMonthList(myChart){

        let option;
        //let that = this;
        //console.log("JYSSSSBA"+JSON.stringify(this.YearCupCount))
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['销量'],
            textStyle: { // 设置图例文本样式
              color: '#000000' // 设置图例文本颜色为紫色
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '30%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月'],
            axisLine: { // X 轴线样式配置
              lineStyle: {
                color: '#000000' // 设置 X 轴线的颜色为红色
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: { // X 轴线样式配置
              lineStyle: {
                color: '#000000' // 设置 X 轴线的颜色为红色
              }
            }
          },
          series: [
            {
              name: '销量',
              type: 'line',
              stack: 'Total',
              areaStyle: {color:'rgb(220,118,118)'},
              smooth: true,
              data: this.YearCupCount,
              lineStyle: { // 设置数据线样式
                color: 'rgba(147,146,134,0.98)' // 设置数据线颜色为绿色
              }
            }
          ]
        };
        option && myChart.setOption(option);
        myChart.hideLoading();
      },
      //加载设备在线离线数量
      loadEquipStateNumber(){
        let that = this;
        return this.$httpservice.get("api/Analysis/CountOfIndividualEquipmentState").then(
          function (data) {
            if(data.body.code=="200"){
              that.equipStateNumberList = data.body.data;
            }else{
              that.$message({
                message: data.body.msg,
                type: 'warning'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      screen() {
        let element = document.getElementById('screen');
        if (this.fullscreen) {
          // 关闭全屏
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          // 全屏
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
    }

  }
</script>

<style scoped>
.xssj .el-icon-loading{
  margin-bottom: 105px;

}
.image-container {
  display: flex;
  margin-top: 25px;
  justify-content: space-around; /* 调整图片间距 */
  position: relative;
}
.image-container1 {
  display: flex;
  margin-top: 40px;
  margin-bottom:25px ;
  justify-content: space-around; /* 调整图片间距 */
  position: relative;
}
.image {
  width: 200px; /* 设置图片宽度 */
  height: auto; /* 保持宽高比例 */
  margin-top: 0px;
  /* 其他样式 */
}
.image1 {
  width: 125px; /* 设置图片宽度 */
  height: auto; /* 保持宽高比例 */
  margin-left: 10px;
  /* 其他样式 */
}
.image2 {
  width: 250px; /* 设置图片宽度 */
  height: auto; /* 保持宽高比例 */
  margin-right: 10px;
  /* 其他样式 */
}
.image3 {
  width: 350px; /* 设置图片宽度 */
  height: auto; /* 保持宽高比例 */
  /* 其他样式 */
}
.screen {
  width: 100%;
  height: 100%;
  background-color: #F1F3F5;
  border: 1px solid #F1F3F5;
}
  input{ margin:0; padding:0; border:none; outline:none;}
  img{ border: none;}
  ul,li{ list-style:none;}
  a{ color:black; font-family:"微软雅黑";}
  a:visited{ color:black;}
  .box{overflow:hidden;float:right;padding:10px;background:#F1F3F5;width: calc(100% - 0px);height: calc(100% - 0px) !important;
    /* height: calc(100vh - 100px);*/}
  .box .box01{  border-radius:5px;width:calc(25% - 20px);float:left;height: 1800px;}
  .box .box02{ width:calc(52% - 40px);float:left;margin:0px 10px;}
  .box .box03{  border-radius:5px;width:calc(25% - 12px);height: 765px;float:left;}
  .box .screenall{  border-radius:5px;width:calc(25% - 20px);height: 25px;float:left;}

  .box .box_bt{ overflow:hidden;margin-top:0px;}
  .box .box_bt a{ display:block; float:left; font-size:16px;color:#06152e; font-weight:bold;line-height:26px;}
  .box .box_bt .xq{ font-weight:normal; text-decoration:none;font-size:15px;color:#436ee5;float:right;padding:0px 5px ; border-radius:3px;}
  .box .box_bt .xq:hover{ background:#efeef3;}
  /*今日销售数据*/
  .box .xssj{/*margin-bottom:5px;*/ border: 3px solid #EDEDED;height:114%;background:#FFFFFF;border-radius: 5px; padding: 10px;}
  .box .box01 ul{ overflow:hidden;margin-top:10px;padding:0px;width:100%;}
  .box .box01 ul li{ width:calc(50% - 6px);height:65px;float:left; border-radius:5px; border:solid 1px #e6e6e6;padding:1.5% 2%;margin:1.5% 0;}
  .box .box01 ul li .xssj_img{ display:block;width:25%;border-radius:44px; background:#f7f9fd;float:left;margin-top:3%; line-height:0px !important;}
  .box .box01 ul li .xssj_img img{width:90%;height:95%;}
  .box .box01 ul li .xssj_right{display:block;width:70%;float:right;margin-top:12px}
  .box .box01 ul li .xssj_right span{display:block;font-size:15px;color:#666;line-height:24px;}
  .box .box01 ul li .xssj_right span font{font-size:22px;color:#000;margin-right:5px;}

  ul.m1 li{ width:calc(50% - 6px);height:65px;float:left; border-radius:5px; border:solid 1px #e6e6e6;padding:1.5% 2%;margin:1.5% 0;}
  ul.m1 li .xssj_img{ display:block;width:25%;border-radius:44px; background:#f7f9fd;float:left;margin-top:3%; line-height:0px !important;}
  ul.m1 li .xssj_img img{width:90%;height:95%;}
  ul.m1 li .xssj_right{display:block;width:70%;float:right;}
  ul.m1 li .xssj_right span{display:block;font-size:15px;color:#666;line-height:40px;}
  ul.m1 li .xssj_right span font{font-size:22px;color:#000;margin-right:5px;}

  .xssj_right1{display:block;width:77%;float:right;padding: 15px 0px 0px 0px;font-size: 17px;font-weight: bold;}
  .xssj_right1 span{display:block;font-size:15px;color:#666;line-height:24px;}
  .xssj_right1 span font{color: rgb(177, 12, 27);font-weight: bold;font-size: 25px;margin-right:5px;}

  /*@media screen and (max-width:100px) {
    .box .box01 ul li .xssj_right span font{font-size:20px;color:#000;margin-right:5px;}
  }*/
  /*今日设备排行榜*/
  .button_111{ margin-top:5px;margin-right: 1px;}
  .sbph{margin: 3% 0 2%; max-height: 67%;background:#FFFFFF;padding: 10px;border-radius: 5px;}
  .sbph table{width:100%;margin-top:20px;}
  .sbph table td{font-size:16px;color:#333; text-align:center;line-height:2.2;}
  .bph_tr01 td{ background:#f7f9fd;color:#516680 !important;line-height:2.5 !important;}
  .sbph table a{ display:block;border-radius:30px;width:20px;line-height:20px;margin:0 auto; position:relative;left:20px;}
  .sbph1_td03{font-size:18px;font-weight:bold;color:#FBBE49;}
  .sbph2_td03{font-size:18px;font-weight:bold;color:#B7C7D8;}
  .sbph3_td03{font-size:18px;font-weight:bold;color:#E0B992;}
  .sbph4_td03{color: #000000}
  .sbph5_td03{background-image: url("../../assets/images/bg31.png");background-size: 100% 100%}
  .sbph_one{/*background:#ffe8ec;*/color:#0126BA;background-repeat: no-repeat;background-image: url("../../assets/images/bg32.png");background-size: 45% 100%;}
  .sbph_two { color:#0126BA;background-repeat: no-repeat;background-image: url("../../assets/images/bg33.png");background-size: 45% 100%;}
  .sbph_three { color:#0126BA;background-repeat: no-repeat;background-image: url("../../assets/images/bg34.png");background-size: 45% 100%;}
  .sbph_four { color: #000000;text-align: left;}
  .sbph_tr01{margin-bottom: 10px;font-weight: bold;}
  .sbph_row01{margin: 1px 0 1px;font-size: 15px;}
  /*历史原料排行榜*/
  .box .box01 .lsyl{/*margin-top:15px;*/height:40%;width:100%;}
  .box .box01 .lsyl .tb{margin-top:10px;text-align:center;padding:3% 0;height:96%;}
  .box .box01 .lsyl .tb img{ margin:0 auto;width:94%;height:85%;}
  /*省区域排行榜*/
  .box .box03 .sqy{width:100%;height:35%;border: 3px solid #E8E9EA;background: #ffffff;border-radius: 5px;padding: 10px;}
  .box .box03 .sqy1{width:100%;height:46%;border: 3px solid #E8E9EA;background:#ffffff;border-radius: 5px;padding: 10px;}
  .box .box03 .sqy1 .tb{margin-top:1px;text-align:center;height:92%;}
  .box .box03 .sqy1 .tb img{ margin:0 auto;width:96%;height:94%;}


  /*历史销售排行榜*/
  .lsxs{margin-top:10px;background:#090F44; border: 3px solid #1B4CB5;border-radius:5px;padding:10px;height:100%}
  .lsxs ul{ overflow:hidden;margin-top:10px;}
  .lsxs ul li{display:block; border-right:solid 1px #ededed;width:calc(25% - 1px);float:left; text-align:center;}
  .lsxs ul li a{ display:block;font-size:16px;color:#999;line-height:22px; width:100%;}
  .lsxs ul li a font{font-size:24px;color:#ff6d3c;font-weight:bold;margin-right:5px;}
  .lsxs ul li span{ display:block;font-size:16px;color:#333;width:100%;}

  .map{margin-top:0px;background:#000E21; border-radius:5px;padding:1px;height:520px; position:relative;}
  .map .map_img{width:100%; height:100%;text-align:center;}
  .map .map_img img{width:100%;height:100%;}

  .xssj_img1{
    width: 35px;
    height: 30px;
    padding-left: 10px;
    padding-top: 5px;
  }
  .xssj_img2{
    width: 35px;
    height: 30px;
    margin-right: 10px;
    padding-top: 5px;
  }
  .xssj_img0{
  width: 40px;
  height: 10px;
  padding-left: 0;
  padding-top: 3px;
}

  .box .box02  .map .map_bottom{overflow:hidden; position:absolute;bottom:4%;left:2%;text-align:center;margin:0 auto;background:rgba(255,255,255,0.8); border:solid 1px #cacee5; border-radius:30px;width:95%;padding:10px 0px;}
  .box .box02  .map .map_bottom li{ float:left; overflow:hidden;margin:0px 4px;}
  .box .box02  .map .map_bottom li img,span,a{ display:inline-block;float:left;line-height:40px;color:#666;}
  .box .box02  .map .map_bottom li span{ margin:0px 10px;}
  .box .box02  .map .map_bottom li a{ margin:0px 3px;font-size:18px;font-weight: bolder;display:block;width:80px}

  .box .box02  .map .map_bottom2{overflow:hidden; position:absolute;bottom:14%;right:3%;text-align:center;margin:0 auto;background:rgba(255,255,255,0.8); border:solid 1px #cacee5; border-radius:30px;width:28%;padding:10px 0px;}
  .box .box02  .map .map_bottom2 li{ float:left; overflow:hidden;margin:0px 4px 0px 25px;}
  .box .box02  .map .map_bottom2 li img,span,a{ display:inline-block;float:left;line-height:40px;color:#666;}
  .box .box02  .map .map_bottom2 li img,span,a:hover{cursor:pointer}
  .box .box02  .map .map_bottom2 li span{ margin:0px 10px;}
  .box .box02  .map .map_bottom2 li a{ margin:0px 3px;font-size:16px;font-weight: bolder;display:block;width:80px}
/* .box .box02  .map .map_bottom2 li a :hover{cursor:pointer} */


  .box .box02  .map .map_top{overflow:hidden; z-index: 100; position:absolute;top:2%;right:2%;text-align:center;margin:0 auto; background:#f7f9fd; border-radius:5px; border:solid 1px #e3e3e3;padding:5px 0px;}
  .box .box02  .map .map_top li{ float:left;margin:0px 5px;}
  .box .box02  .map .map_top li a{ display:inline-block; float:left;line-height:20px;margin-right:5px;}
  .box .box02  .map .map_top li select{ display:inline-block; float:left; border:none; outline:none;height:20px;padding:0px 5px; background:none;}


  @-webkit-keyframes animate1 {
    from {transform: translateX(150%)}
    to {transform: translateX(-100%)}
  }
  @keyframes animate1 {
    from {transform: translateX(150%)}
    to {transform: translateX(-100%)}
  }
  .cssanimate{
    animation:animate1 10s linear 0s infinite forwards;
    -webkit-animation:animate1 10s linear 0s infinite forwards;
  }

          .box111 {
            margin: 0 auto;
            overflow: hidden;
        }

        .animate {
            padding-left: 20px;
            font-size: 12px;
            color: #000;
            display: inline-block;
            white-space: nowrap;
            /*animation: 12s wordsLoop linear infinite normal;*/
        }

        @keyframes wordsLoop {
            0% {
                transform: translateX(200px);
                -webkit-transform: translateX(200px);
            }
            100% {
                transform: translateX(-100%);
                -webkit-transform: translateX(-100%);
            }
        }

        @-webkit-keyframes wordsLoop {
            0% {
                transform: translateX(200px);
                -webkit-transform: translateX(200px);
            }
            100% {
                transform: translateX(-100%);
                -webkit-transform: translateX(-100%);
            }
        }
/*  .box {
    @media screen and (max-width: 1920px) {
      #main {
        height: 10%;
      }
    }
  }*/
</style>
<style lang="less">
#homepage{
  .box englishStyle{
    .el-table th{
      font-size: 12px!important;
    }
  }
  .box{
    @media screen and (max-width: 1366px) {
      #main{
        height: 65vh!important;
        width:120vh!important
      }
      .map{
        height: 20vh!important;
      }
    }
    @media screen and (min-width: 1367px) and (max-width: 1920px) and (max-height: 1080px) {
      #main{
        height:45vh!important;
        width:85vh!important
      }
      .map{
        height: 51vh!important;
      }
    }
    @media screen and (min-width: 2500px) {
      #main{
        height: 30vh!important;
        width:55vh!important
      }
    }
  }
}
</style>
<script setup>
</script>



// WEBPACK FOOTER //
// src/pages/homepage/homepage.vue